import GroupRepository from '../../repositories/GroupRepository';
import Vue from 'vue';
import DeviceRepository from '../../repositories/DeviceRepository';

export default {
	namespaced: true,
	state: {
		current: null
	},
	mutations: {
		current: (state, group) => {
			state.current = group;
		},
		SET_GROUP_NOTIFICATIONS: (state, notifications) => {
			Vue.set(state.current, 'notifications', notifications);
		},
		SET_GROUP_DEVICES: (state, devices) => {
			Vue.set(state.current, 'devices', devices);
		},
		UPDATE_MONITOR_COUNT: (state, count) => {
			state.current.monitor_count = count;
		}
	},
	actions: {
		load ({ commit, getters, dispatch }, groupId) {
			return GroupRepository.findWithDeviceTypes(getters['client'].id, groupId)
				.then(data => {
					commit('current', data);

					return data;
				});
		},
		notifications ({ commit, getters }, id) {
			return GroupRepository.getNotifications(id)
				.then(data => {
					commit('SET_GROUP_NOTIFICATIONS', data);

					return data;
				});
		},
		getDevicesByType ({ commit, getters }, requestData) {
			return DeviceRepository.getFromGroupWithDeviceType(requestData.clientId,
				requestData.groupId,
				requestData.typeId,
				requestData.page, requestData.sortBy, requestData.sortDirection, requestData.filter)
				.then(data => {
					commit('SET_GROUP_DEVICES', data.data);

					return data;
				});
		},
		getGroups ({ commit, getters }, groupId) {
			return GroupRepository.getGroups(groupId);
		},
		getDevices ({ commit, getters }, groupId) {
			return GroupRepository.getDevices(groupId);
		},
		activate ({ commit, getters }, request) {
			return GroupRepository.activateGroup(request.groupId, request);
		},
		deactivate ({ commit, getters }, groupId) {
			return GroupRepository.deactivateGroup(groupId);
		},
		deleteGroup ({ commit, getters }, data) {
			return GroupRepository.deleteGroup(data.id, data.newGroup || '');
		}
	},
	getters: {
		client: (state, getters, rootState, rootGetters) => rootGetters['clients/current'],
		current: state => state.current
	}
};
